/**
 * Демо-режим (гостевой read-only вход).
 *
 * Включается query-параметром `?demo=1` (лендинг открывает
 * app.parallaxgps.ru/?demo=1 в iframe). При старте приложения, если
 * демо-режим активен, фронт автоматически логинится фиксированным гостевым
 * аккаунтом (см. App.tsx). Гость не может ничего менять — бэкенд режет
 * мутации guard'ом по роли GUEST_ROLE_ID; на фронте мутирующие кнопки
 * дополнительно дизейблятся (useIsReadOnly).
 */

/**
 * Креды публичного read-only демо-аккаунта. Зашивать их в код фронта
 * осознанно допустимо: аккаунт не может ничего менять. Держим в одном
 * месте, чтобы легко поменять и не разбрасывать по коду.
 */
export const DEMO_GUEST_EMAIL = "mossnabitkana1@gmail.com";
export const DEMO_GUEST_PASSWORD = "1234";

// Флаг держим в памяти модуля: query-параметр может потеряться при
// внутренней навигации SPA-роутера, поэтому фиксируем демо-режим один раз
// на всё время жизни вкладки.
let demoModeLatched = false;

/**
 * Активен ли демо-режим в текущей вкладке.
 *
 * При первом вызове читает `?demo=1` из URL; если найден — «защёлкивает»
 * флаг, и дальше демо-режим считается включённым до перезагрузки страницы,
 * даже если параметр исчезнет из URL после переходов роутера.
 */
export const isDemoMode = (): boolean => {
    if (demoModeLatched) return true;
    if (typeof window === "undefined") return false;
    const params = new URLSearchParams(window.location.search);
    if (params.get("demo") === "1") {
        demoModeLatched = true;
    }
    return demoModeLatched;
};
